export const TRASH_RETENTION_DAYS = 30;
/** Yjs doc structure names — the only keys ever used inside docs. */
export const DOC_KEYS = {
    /** Y.Text on a note doc holding the raw markdown source. */
    noteContent: "content",
    /** Y.Map<WorkspaceItem-shaped Y.Map> on the workspace doc. */
    workspaceItems: "items",
    /** Y.Map<TaskItem-shaped Y.Map> on a task-list doc. */
    taskItems: "tasks",
};
/**
 * Document naming on the sync server. A "space" is either a personal
 * workspace or a shared folder; note docs use the same shape for both, so
 * every consumer keyed by an opaque space id string works for either kind.
 */
export const docName = {
    workspace: (workspaceId) => `ws.${workspaceId}`,
    /** Tree doc of a shared folder (same structure as a workspace doc). */
    sharedFolder: (folderId) => `sf.${folderId}`,
    note: (spaceId, noteId) => `note.${spaceId}.${noteId}`,
    /** A task list's doc. Same space semantics as note docs. */
    task: (spaceId, listId) => `task.${spaceId}.${listId}`,
};
export function parseDocName(name) {
    const parts = name.split(".");
    if (parts[0] === "ws" && parts.length === 2 && parts[1]) {
        return { kind: "workspace", spaceId: parts[1] };
    }
    if (parts[0] === "sf" && parts.length === 2 && parts[1]) {
        return { kind: "sharedFolder", spaceId: parts[1] };
    }
    if (parts[0] === "note" && parts.length === 3 && parts[1] && parts[2]) {
        return { kind: "note", spaceId: parts[1], noteId: parts[2] };
    }
    if (parts[0] === "task" && parts.length === 3 && parts[1] && parts[2]) {
        return { kind: "task", spaceId: parts[1], listId: parts[2] };
    }
    return null;
}
//# sourceMappingURL=model.js.map